import { render, staticRenderFns } from "./BelongingsStep.vue?vue&type=template&id=4602d57e"
import script from "./BelongingsStep.vue?vue&type=script&lang=ts"
export * from "./BelongingsStep.vue?vue&type=script&lang=ts"
import style0 from "./BelongingsStep.vue?vue&type=style&index=0&id=4602d57e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports